import { Box, useMediaQuery } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getArtistsByGroupName } from '../../components/apis/music-api';
import { format } from '../../components/text-helper/text-helper';
import { AuthenticationContext } from '../../components/authentication/AuthenticationContext';
import { ArtistMessage } from '../../types/ArtistMessage';
import callApi from '../../components/call-api/call-api';

type LetterProps = {
    letter: string
}

const Letter = () => {
  const params = useParams<LetterProps>();
  const { getAccessToken } = useContext(AuthenticationContext);
  const [ artistMessages, setArtistMessages ] = useState<ArtistMessage[]>();
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    
  useEffect(() => {
    callApi<ArtistMessage[]>(getArtistsByGroupName(getAccessToken(), params.letter ?? ''), setArtistMessages);
  }, [params.letter, getAccessToken]);

  return (
    <>
      <h2>{params.letter}</h2>
      <p>{artistMessages?.length} artists</p>
      {artistMessages?.map((artist: ArtistMessage, index: number) =>
        <Box component={Link}
          sx={{ 
            width: isSmall ? '100%' : '360px',
            display: 'inline-flex',
            p: '6px',
            m: '2px',
            backgroundColor: artist.backgroundColor,
            color: artist.color == null || artist.color === "" ? '#666666' : artist.color ,
            textDecoration: 'none',
            fontWeight: 'bold',
            borderRadius: '6px'
          }}
          key={`$artist-${index}`}
          to={`/letters/${params.letter}/artists/${artist.name}`}
        >
          {format(artist.name)}
        </Box>
      )}
    </>
  )
}

export default Letter;